import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import moment from 'moment';
import { useIntl } from 'react-intl';
import messages from './FieldMessages';
// The audit API serializes the planned registration with PascalCase properties
const getProperty = (value, name) => { var _a; return (_a = value[name]) !== null && _a !== void 0 ? _a : value[name.charAt(0).toLowerCase() + name.slice(1)]; };
export const describePlannedRegistration = (value, intl) => {
    if (!value)
        return '';
    if (typeof value === 'string')
        return value;
    const name = [getProperty(value, 'ScheduleName'), getProperty(value, 'ResourceName')]
        .filter(Boolean)
        .join(' - ');
    const startDate = getProperty(value, 'StartDate');
    if (!startDate)
        return name;
    return intl.formatMessage(messages.PlannedRegistrationStartingOn, {
        name,
        startDate: moment(startDate).format('LL'),
    });
};
const PlannedRegistrationChange = ({ log }) => {
    const intl = useIntl();
    const isAdded = log.oldValue === null;
    return (_jsx("span", { children: intl.formatMessage(isAdded ? messages.AddedPlannedRegistration : messages.DeletedPlannedRegistration, {
            name: _jsx("b", { children: describePlannedRegistration(isAdded ? log.newValue : log.oldValue, intl) }),
        }) }));
};
export default PlannedRegistrationChange;
